import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/ITSCoupons/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/node_modules/next/font/local/target.css?{\"path\":\"node_modules/geist/dist/sans.js\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/geist-sans/Geist-Variable.woff2\",\"variable\":\"--font-geist-sans\",\"weight\":\"100 900\"}],\"variableName\":\"GeistSans\"}");
;
import(/* webpackMode: "eager" */ "/var/www/ITSCoupons/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/AdminEditToolbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdBillboard","AdRectangle2","AdRectangle1","AdAnchor","AdInterstitial"] */ "/var/www/ITSCoupons/src/components/ads/GptAd.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/Breadcrumbs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/GoogleAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/ITSCoupons/src/components/ScrollToTopButton.tsx");
